//begin code card ID: 529
/**
 * Instance of a private conversation
 */
import {
    socket,
    room,
    Video,
    CONV_STORAGE
} from '../libs/roomnew';
export default class PrivateConversation {
    constructor(conversation_id,from_id) {
        this.id = conversation_id;
        this.myId = room && room.myUserId();
        this.forwardedAudioEndpoints = [];
        this.from_id=from_id;
    };

    onParticipantsChanged() {
        this.sendPrivateStreamIds();
    };
    sendAudioToParticipantsList(participants,tries=0) {
        try {
            const hasRemoteRoomParticipants = room && room.getParticipants && room.getParticipants().length > 0;
            if(tries >= 20){
                if(CONV_STORAGE.myConversation){
                    CONV_STORAGE.leaveSpace();
                }
                throw new Error("Failed to send private participant ids")
            }
            if (room && room.rtc._channel && room.rtc._channel.isOpen()) {
                console.error("ForwardAudioToMessage", participants);
                room.rtc._channel._send({
                    colibriClass: 'ForwardAudioToMessage',
                    forwardAudioTo: participants
                });
                this.forwardedAudioEndpoints = new Array(...participants);
            } else {
                if(!hasRemoteRoomParticipants){
                    return;
                }
                console.error("SENDING ForwardAudioToMessage NO OPEN CHANNEL", participants);
                setTimeout(() => {
                    this.sendAudioToParticipantsList(participants,tries + 1)
                }, 100);

            }
        } catch (error) {
            if(!(room && room.getParticipants && room.getParticipants().length > 0)){
                return;
            }
            console.error("SENDING ForwardAudioToMessage Error:", error);
            setTimeout(() => {
                this.sendAudioToParticipantsList(participants,tries + 1)
            }, 100);
        }

    };
    sendPrivateStreamIds() {
        let participants = this.getConversationParticipants();
        this.sendAudioToParticipantsList(participants.length ? participants : [room.myUserId()]);
    };
    stopSendingStreamsPrivate() {
        this.sendAudioToParticipantsList([]);
    };
    getConversationParticipants() {
        return CONV_STORAGE.conversations[this.id].participants.filter(p => p != this.myId);
    };
    start() {
        //this.notifyPrivateStart();
        this.sendPrivateStreamIds();
        console.log("Space participants", this.getConversationParticipants());
    };
    startSilent(data) {
        this.sendPrivateStreamIds();
        this.showNotification('<i class="fas fa-lock fa-lg"></i>', 'CONVERSATION_MADE_PRIVATE', data);
    };
    destroySilent(data) {
        this.showNotification('<i class="fas fa-unlock fa-lg"></i>', 'CONVERSATION_MADE_NOT_PRIVATE', data);
        this.stopSendingStreamsPrivate();
    };
    destroy() {
        //this.notifyPrivateStop();
        this.stopSendingStreamsPrivate();
    }
    notifyPrivateStart() {
        this.sendSocketMessage('make_private', {});
    }
    notifyPrivateStop() {
        this.sendSocketMessage('make_not_private', {});
    }
    sendJoinConversationInvite(participant){
        this.sendSocketMessage("invite_to_conversation", {participant:participant,name:MY_NAME});
    };
    handleMessage(message) {
        switch (message.action) {
            case 'JoinRequest':
                this.showNotification('', 'CONVERSATION_JOIN_REQUEST', message.data);
                break;
            case 'RemoveRequest':
                this.removeRequestEvent(message);
                break;
            default:
                break;
        }
    };

    showNotification(icon, type, data = {}, text = '') {
        var p = this;

        let icondiv = $('<div/>', {
            class: 'icon',
            style: "color:#fff",
            html: icon,
        });
        let action = '';
        let action2 = '';
        let dismiss = '';
        let space = '&nbsp;';
        let notificationTimeout = 10000;
        let closediv = $('<div/>', {
            class: 'close',
            html: `<i class="icofont-close icofont-1x"></i>`,
        });
        console.log("Show notification for " + type);
        let participant;
        let fromName='You';
        if (data.from_id && data.from_id != 'moderator' && data.from_id != room.myUserId()) {
            participant = room.getParticipantById(data.from_id);
            if(participant){
                fromName=participant.getDisplayName();
            }else{
                fromName="Moderator";
            }
        }else if(data.from_id == 'moderator'){
            fromName="Moderator"
        }
        $(`#notificationsBanner`).find(".CONVERSATION_MADE_PRIVATE").remove();
        $(`#notificationsBanner`).find(".CONVERSATION_MADE_NOT_PRIVATE").remove();
        switch (type) {

            case 'CONVERSATION_MADE_PRIVATE':
                notificationTimeout = 5000;
                text = `${fromName} made this space private`;
                break;
            case 'CONVERSATION_MADE_NOT_PRIVATE':
                notificationTimeout = 5000;
                text = `This space is no longer private`;
                break;
            case 'CONVERSATION_JOIN_REQUEST':
                text = `${participant.getDisplayName()} wants to join this space`;
                action = $('<button/>', {
                    class: 'btn btn-sm btn-light btn-rounded mr-1 ml-2',
                    html: 'Accept',
                }).on('click', function () {
                    closediv.click();
                    p.acceptRequest(data);
                });
                action2 = $('<button/>', {
                    class: 'btn btn-sm btn-outline-light btn-rounded',
                    html: 'Reject',
                }).on('click', () => {
                    p.rejectRequest(data);
                    closediv.click();
                });
                break;
            default:
                return;
                break;
        }
        dismiss = $('<button/>', {
            class: 'btn btn-sm btn-outline-danger btn-rounded ml-2',
            html: 'Dismiss',
        }).on('click', () => {
            closediv.click();
        });

        let textdiv = $('<div/>', {
            class: 'text',
            html: [text, space, space, action, space, action2, space, dismiss],
        });

        let pid = data.from_id;

        let container = $('<div/>', {
            class: `notificationContent private-request-${data.request_id} ${type} conversation${data.conversation_id}`,
            id: `${pid}-private-notification`,
            html: [icondiv, textdiv, closediv],
        });

        let timeout = setTimeout(function () {
            p.hideNotification(container);
        }, notificationTimeout);


        closediv.on('click', function (e) {
            if (typeof timeout !== 'undefined') {
                clearTimeout(timeout);
            }
            p.hideNotification(container);

        });
        container.appendTo(Video.notifications);
    };

    hideNotification(notification) {
        $(notification).remove();
    };

    acceptRequest(request) {
        let p=this;
        p.sendSocketMessage('accept_request',{request_id:request.request_id});
        CONV_STORAGE.userJoiningPrivateSpace(p.id, request.from_id);
    };
    rejectRequest(request) {
        let p=this;
        p.sendSocketMessage('reject_request',{request_id:request.request_id,participant:request.from_id});
        CONV_STORAGE.userJoiningPrivateSpace(p.id, request.from_id);
    };
    removeRequestEvent(event) {
        console.log("Remove request handler",event)
        Video.notifications.find(`.private-request-${event.data.request_id}`).remove();
    }
    sendSocketMessage(action, message) {
        try {
            //let data=JSON.stringify(message);
            let messageBody = {
                eventName: "PrivateConversation",
                action,
                from_id: room.myUserId(),
                conversation_id: this.id,
                data: message,
                room_id: room.getName()
            };
            socket.connection.send(JSON.stringify(messageBody));
        } catch (error) {
            console.error("Send socket message error", error);
        }

    };

};
//end code card ID: 529
